import RequestAgentInterface from "../RequestAgentInterface";

// returns the response body for successful axios request
// error responses are uncaught here and bubble up
class AxiosRequestAgentResBodyDecorator extends RequestAgentInterface {
    constructor(axiosRequestAgent) {
        super();
        this.axiosRequestAgent = axiosRequestAgent;
    }

    get = async (url, headers) => {
        const response = await this.axiosRequestAgent.get(url, headers);
        const formattedResponse = this._addHttpStatusToResBody(response);
        return formattedResponse.data;
    }

    post = async (url, body, headers) => {
        const response = await this.axiosRequestAgent.post(url, body, headers);
        const formattedResponse = this._addHttpStatusToResBody(response);
        return formattedResponse.data;
    }

    _addHttpStatusToResBody = (response) => {
        if (typeof response.data !== "object") return response;
        response.data._http_status = response.status;
        return response;
    }
}

export default AxiosRequestAgentResBodyDecorator;
